import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { ReportingInfoDto } from './production-log-reporting.dto';


export class ReportingInfoResponseModel extends GlobalResponseObject {
    data?: ReportingInfoDto[];
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: ReportingInfoDto[]){
        super(status,intlCode,internalMessage)
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

